// States Map
var statesMapSVG = jq('#states-map svg');
if (statesMapSVG.length) {
    var states = JSON.parse(document.getElementById('property-state-list').innerHTML) || {};
    jq.each(states, function(key, value) {
        var stateID = key.replace(/\s/g, '');
        var stateFill = jq('#' + stateID);
        if (stateFill.length) {
            stateFill.addClass(value).attr('title', key);    
        }
    });

    jq('g.us path').each(function(e) {
        var id = jq(this).attr('id');
        var rex = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
        var title = id.replace( rex, '$1$4 $2$3$5' );
        jq(this).attr('title', title);
    });

    jq('.existing', statesMapSVG).click(function() {
        jq('.active', statesMapSVG).removeClass('active');
        jq('.state-property-list:not(.hide)').addClass('hide');
        jq('#properties-by-state .map-directions').addClass('hide');
        jq(this).addClass('active');
        var state = jq(this).attr('title');
        jq('.state-property-list[data-state="' + state + '"]').removeClass('hide');
        goToByScroll('#properties-by-state');
    });
    
    // Hover state logic for label positioning
    jq(document).on('mousemove', function(e){
      jq('.map-description').css({
        left:  e.pageX,
        top:   e.pageY - 70
      });
    });
    
    // On mouseover, grab the title which is the state name and display it
    jq('#states-map svg path[title]').mouseover(function() {
        jq(".map-description").html(jq(this).attr('title'));
        jq(".map-description").addClass('display-block');
    });
    
    // On mouseleave, remove the description
    jq('#states-map svg path[title]').mouseleave(function() {
        jq(".map-description").removeClass('display-block');
    });
    
    jq('.fancybox-property-modal').fancybox({
        touch : false,
        helpers: {
            overlay: {
                locked: true
            }
        },
        beforeShow : function(instance, slide) {
            console.log('beforeShow');
            // Find our slider
            propertySlider = jq(slide.src).find('.property-slider');
            
            // If the slider exists and has been initialized, refresh it. If it exists and has not been initialized, initialize it.
            if (propertySlider.length && propertySlider.hasClass('slick-initialized')) {
                console.log('refresh');
                propertySlider.slick('refresh');
            } else if (propertySlider.length && !propertySlider.hasClass('slick-initialized')) {
                // Initialize the slider
                propertySlider.slick({
                  accessibility: false,
                  autoplay: true,
                  autoplaySpeed: 2000,
                  fade: true,
                  dots: true,
                  arrows: false,
                  lazyLoad: 'progressive',
                  adaptiveHeight: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                });
            }
            
        },
        afterClose : function(instance, slide) {
            // Find the initialized sliders
            console.log('afterClose');
            propertySlider = jq('.property-slider.slick-initialized');
            
            // If the slider exists, kill it.
            if (propertySlider.length) {
                propertySlider.slick('unslick');
            }
        }
    });
}

// QMOD Quote Page Select
jq('#quote-page-select').on('change', function () {
    var url = jq(this).val(); // get selected value
    if (url) { // require a URL
      window.location = url; // redirect
    }
    return false;
});